<template>
  <div class="btn-wrapper mt-1 clearfix">
    <div
      class="btn"
      v-for="(item, n) in btns"
      :key="n"
      :class="{'active': value === item.value}"
      @click.stop="change(item)">{{ item.text }}</div>
  </div>
</template>

<script>
export default {
  name: 'BillControlHeaderBtns',
  props: {
    btns: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    change (item) {
      this.$emit('input', item.value)
    },
  },
}
</script>

<style lang="less" scoped>
.btn-wrapper {
  .btn {
    border: 1px solid #ccc;
    float: left;
    font-size: 12px;
    font-weight: 500;
    height: 24px;
    line-height: 24px;
    width: 60px;
    text-align: center;
    cursor: pointer;
    color: #ccc;
    &:first-child {
      border-right: 0;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:first-child.active {
      border-right: 1px solid #c8e2f7;
    }
    &:last-child {
      border-left: 0;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    &:last-child.active {
      border-left: 1px solid #c8e2f7;
    }
    &.active {
      color: #5d6f80;
      border-color: #c8e2f7;
      box-shadow: 0 1px 6px 0px #c8e2f7;
    }
  }
}
</style>
